(() => {
  const initContactCarousel = (root) => {
    const track = root.querySelector('[data-contact-carousel-track]');
    const cards = Array.from(root.querySelectorAll('[data-contact-carousel-card]'));
    const dots = Array.from(root.querySelectorAll('[data-contact-carousel-dot]'));

    if (!track || cards.length === 0 || dots.length === 0) return;

    let currentIndex = 0;
    let scrollFrame = null;
    let hasPositioned = false;

    const itemLeft = (card) => {
      if (window.matchMedia('(max-width: 749px)').matches) {
        const scrollPadding = Number.parseFloat(window.getComputedStyle(track).scrollPaddingLeft) || 0;
        return card.offsetLeft - track.offsetLeft - scrollPadding;
      }
      return card.offsetLeft - track.offsetLeft - ((track.clientWidth - card.offsetWidth) / 2);
    };

    const updateDots = (index) => {
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const select = (index, behavior = 'smooth') => {
      const next = Math.max(0, Math.min(index, cards.length - 1));
      currentIndex = next;
      updateDots(next);
      track.scrollTo({ left: itemLeft(cards[next]), behavior });
    };

    const updateFromScroll = () => {
      scrollFrame = null;
      const trackCenter = track.scrollLeft + (track.clientWidth / 2);
      let nearest = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      cards.forEach((card, index) => {
        const center = card.offsetLeft - track.offsetLeft + (card.offsetWidth / 2);
        const distance = Math.abs(center - trackCenter);
        if (distance < nearestDistance) {
          nearest = index;
          nearestDistance = distance;
        }
      });

      if (nearest !== currentIndex) {
        currentIndex = nearest;
        updateDots(nearest);
      }
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => select(Number(dot.dataset.index || 0)));
    });

    track.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(updateFromScroll);
    }, { passive: true });

    const positionCurrentCard = () => {
      if (!hasPositioned) {
        currentIndex = window.matchMedia('(min-width: 750px)').matches && cards.length > 2 ? 1 : 0;
        hasPositioned = true;
      }
      select(currentIndex, 'auto');
    };

    window.requestAnimationFrame(positionCurrentCard);
    window.addEventListener('resize', positionCurrentCard, { passive: true });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-contact-carousel]').forEach((carousel) => {
      if (carousel.dataset.contactCarouselReady === 'true') return;
      carousel.dataset.contactCarouselReady = 'true';
      initContactCarousel(carousel);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
